import { createContext, useContext } from "react";

export const ComplaintDialogContext = createContext();
export const useComplaintDialog = () => {
  const context = useContext(ComplaintDialogContext);
  if (!context) {
    throw new Error("useComplaintDialog must be used inside ComplaintDialog");
  }

  return context;
};
